import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection } from '../../shared/models/index';
import { BasePlugin } from '../base-plugin.component';
import { ObsolescencesPluginService } from './obsolescences-plugin.service';
import { UpgradeDetailsConfig } from '../upgrades/upgrades-plugin.service';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
    templateUrl: './obsolescences.component.html',
    standalone: false
})
export class ObsolescencesPluginComponent extends BasePlugin implements OnInit {
  plugin: any = {};
  inspectionId: string;
  inspection: Inspection;
  loading = false;
  obsolescencesDetailsConfig: UpgradeDetailsConfig[];

  constructor(
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private obsolescencesPluginService: ObsolescencesPluginService
  ) {
    super();
  }

  ngOnInit() { }

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.initData();
    this.cdRef.detectChanges();
  }

  initData() {
    this.obsolescencesPluginService
      .getObsolescencesDetailsConfig(this.inspection.id)
      .subscribe((data) => (this.obsolescencesDetailsConfig = data));

    if (!this.plugin?.config?.Obsolescences?.length) {
      this.loading = true;
      this.obsolescencesPluginService
        .getObsolescences(this.inspection.id, { ignoreLoader: 'true' })
        .pipe(
          switchMap((obsolescences) => {
            obsolescences.forEach((obsolescence) => {
              if (obsolescence.Status !== 'already-installed') {
                obsolescence.Recommended = true;
              }
            });
            this.plugin.config.Obsolescences = obsolescences.map((o) => ({ ...o, Data: JSON.stringify(o) }));
            if (this.plugin.config.Obsolescences?.length) {
              return this.obsolescencesPluginService.updateObsolescences(
                this.inspection.id,
                this.plugin.id,
                this.plugin.config.Obsolescences,
                { ignoreLoader: 'true' }
              );
            }
            return of(null);
          })
        )
        .subscribe(() => {
          this.loading = false;
          this.cdRef.detectChanges();
        });
    }
  }

  getEditRoute() {
    return [
      this.inspection.isTemplate() ? this.templatesRoute : this.inspectionsRoute,
      this.inspection.id,
      'points',
      this.plugin.pointId,
      'plugins',
      this.plugin.id,
      'obsolescences',
      'edit'
    ];
  }

  openDetails(obsolescence: any) {
    this.obsolescencesPluginService.openObsolescencesDetails(
      JSON.parse(obsolescence.Data),
      this.obsolescencesDetailsConfig
    );
  }
}

PluginComponent.plugins['obsolescences'] = ObsolescencesPluginComponent;
